"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultDashboardKpiComponentSetFactory = void 0;
var dragAndDrop_1 = require("../../dragAndDrop/");
var kpiPlaceholder_1 = require("../kpiPlaceholder");
var CreatableKpi_1 = require("./CreatableKpi");
var DefaultKpiConfigurationPanel_1 = require("./DefaultKpiConfigurationPanel/DefaultKpiConfigurationPanel");
/**
 * @internal
 */
function DefaultDashboardKpiComponentSetFactory(kpiProvider) {
    return {
        MainComponentProvider: kpiProvider,
        creating: {
            CreatingPlaceholderComponent: kpiPlaceholder_1.DefaultDashboardKpiPlaceholderWidget,
            CreatePanelListItemComponent: CreatableKpi_1.CreatableKpi,
            type: "kpi-placeholder",
            priority: 5,
        },
        dragging: {
            DraggingComponent: dragAndDrop_1.KpiDraggingComponent,
            type: "kpi",
        },
        configuration: {
            WidgetConfigPanelComponent: DefaultKpiConfigurationPanel_1.DefaultKpiConfigurationPanel,
        },
    };
}
exports.DefaultDashboardKpiComponentSetFactory = DefaultDashboardKpiComponentSetFactory;
//# sourceMappingURL=DefaultDashboardKpiComponentSetFactory.js.map